export default "/assets/images/dust-video-thumbnail.jpg?6950e93b89997bb6f75ac77e96fb3e71";